import { Typography } from "@mui/material";

interface InternalContactsSectionHeaderProps {
  label: string;
}

export const InternalContactsSectionHeader = ({
  label,
}: InternalContactsSectionHeaderProps) => {
  return (
    <Typography
      sx={{
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: "0.08em",
        color: "text.disabled",
        textTransform: "uppercase",
        px: 2.5,
        pt: 2.5,
        pb: 1,
      }}
    >
      {label}
    </Typography>
  );
};
